<template>
<svg :width="width" :height="height" viewBox="0 0 15 14" :fill="color" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.933838 13.7624L3.15158 13.516L3.89083 12.7768L1.9195 10.8055L1.18025 11.5447L0.933838 13.7624ZM2.9048 9.8197L4.87612 11.791L7.0939 9.5733L9.8044 7.8484L14.2399 3.4129L11.2829 0.45591L6.8475 4.8914L5.1225 7.602L2.9048 9.8197Z" fill="black" fill-opacity="0.3"/>
</svg>

</template>

<script>
import {colors} from "../../constants";

export default {
    props: {
        width: { type: [Number, String], default: 15 },
        height: { type: [Number, String], default: 14 },
        color: { type: String, default: colors.iconArinet }
    }
}
</script>
